module.exports = __webpack_public_path__ + "static/media/car.8b7c15ff.svg";